import { OrganisationsTyp } from '../../domain/model/organisationsTyp';
import { Organisation } from '../organisation/organisation';
import Moment from 'moment';

export class NeueAufgabe {
    name: string;
    frist: Moment.Moment;
    mitUenbTeilen: boolean;
    emailBenachrichtigungSenden: boolean;
    erinnerungsMailSenden: boolean;
    emailBenachrichtigungNachVorgangabschluss: boolean;
    kurzbeschreibung: string;
    type: string;
    zuweisungen: OrganisationsTyp[];
    einzelEmpfaengerOrgId: string;
    batchZuweisungen: Organisation[];

    constructor() {
        this.zuweisungen = new Array<OrganisationsTyp>();
        this.kurzbeschreibung = '';
    }

    public static createEmptyNeueAufgabe(): NeueAufgabe {
        return new NeueAufgabe();
    }

}
